import React, { useState } from 'react'
import { ModalCP } from 'submodules/nerit-framework-ui/common/components/modal/ModalCP'
import { TableFromApiCP } from 'submodules/nerit-framework-ui/common/components/table/TableFromApiCP'
import { LocationRequests } from 'submodules/nerit-aquatec-sdk/services/location/LocationRequests'
import { LocationResponseDTO } from 'submodules/nerit-aquatec-sdk/services/location/dtos/responses/LocationResponseDTO'
import { LocationSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/location/dtos/requests/LocationSearchRequestDTO'
import { ButtonDeleteRecordCP } from 'submodules/nerit-framework-ui/common/components/table/columns/ButtonDeleteRecordCP'
import { DataAnalysisRequests } from 'submodules/nerit-aquatec-sdk/services/data-analysis/DataAnalysisRequests'
import { DeleteFieldValuesRequestDTO } from 'submodules/nerit-aquatec-sdk/services/data-analysis/dtos/request/DeleteFieldValuesRequestDTO'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'

interface ICPProps {
    visible: boolean
    onCancel: () => void
    samplingCode: number
}

export function ModalSamplingPointsCP(props: ICPProps): JSX.Element {

    const [reloadData, setReloadData] = useState<number>(1)

    const searchFilters: LocationSearchRequestDTO = {
        samplingCode: props.samplingCode
    }

    return (
        <ModalCP
            visible={props.visible}
            onCancel={props.onCancel}
            title={`Pontos da Campanha #${props.samplingCode}`}
            width={1000}
            noFooter={true}
        >
            <TableFromApiCP<LocationResponseDTO>
                apiConfig={{
                    hasPagination: true,
                    pageSize: 20,
                    requestConfigTP: () => LocationRequests.getList(searchFilters)
                }}
                appearance={{
                    showReloadButton: true,
                    wrappedOnCard: false,
                    showTotalOnHeader: true
                }}
                shouldLoadData={reloadData}
                columns={[
                    {
                        title: '#',
                        render: (text, record) => record.code
                    },
                    {
                        title: 'Nome',
                        render: (text, record) => record.name
                    },
                    {
                        title: 'Descrição',
                        render: (text, record) => record.description
                    },
                    {
                        title: 'Latitude',
                        render: (text, record) => record.latitude
                    },
                    {
                        title: 'Longitude',
                        render: (text, record) => record.longitude
                    },
                    {
                        title: 'Altitude',
                        render: (text, record) => record.altitude || '-'
                    },
                    {
                        title: 'Ações',
                        render: (text, record) => (
                            <ButtonDeleteRecordCP
                                requestConfigTP={() => {
                                    const dto: DeleteFieldValuesRequestDTO = {
                                        samplingCode: props.samplingCode,
                                        locationCode: record.code
                                    }
                                    return DataAnalysisRequests.deleteFieldValues(dto)
                                }}
                                onDelete={() => setReloadData(TableUtils.getReloadNumber())}
                            />
                        )
                    }
                ]}
            />
        </ModalCP>
    )
}
